export default __webpack_public_path__ + "static/media/Codepen.e85ee512.svg";